import { IFRAME_URL } from "../config/consts";
import { IGame, IGamesRequest } from "../interfaces/intefaces";

const getCookie = (name: string) => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName.trim() === name) {
      return cookieValue;
    }
  }
  return null;
};

export const getGameUrl = (game: IGame) => {
  return `/game/?id=${game.id}&plid=${game.plat_user}`;
}

export const getGameIframe = (game: IGame, userIsLoggedIn: boolean, for_fun: boolean) => {
  if (userIsLoggedIn) {
    if (!for_fun) {
    const username = getCookie('animacore-username')
    const token = getCookie('animacore-' + game.plat_user)
    return `${game.url}&username=${username}&token=${token}`
    }else {
      return `${game.url}`
    }
  }else {
    return `${game.url}`

  }

}

export const createRequestJSON = (props: IGamesRequest) => {
  const JSONTemplate: any = {
    mobile: props.mobile,
    hot: props.hot,
    new: props.new,
    nc: 1,
    ps: props.ps
  }
  let data = Object.assign({}, JSONTemplate);

  if (props.category_id > -1) {
    data.category_id = props.category_id;
  }
  data.categoryType = props.categoryType;

  if (props.prs.length) {
    data.prs = props.prs.join(',')
  }
  if (props.nf.length > 0) {
    data.nf = props.nf;
  }
  return data;

}
